"use client"
import React from 'react';
import { Button, CardMedia } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { setContactUs } from 'api/session';
import { useDispatch } from 'react-redux';

const CreateAccount = () => {
    const dispatch = useDispatch();
    const navi = useNavigate();

    return (
        <Button
            color="warning"
            variant='contained'
            onClick={() => dispatch(setContactUs(true))}
            sx={{
                marginLeft: "20px"
            }}
        >
            Create Account
        </Button>
    )
}

export default CreateAccount;